var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_9120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5 103C79.9427 103 103 79.9427 103 51.5C103 23.0573 79.9427 0 51.5 0C23.0573 0 0 23.0573 0 51.5C0 79.9427 23.0573 103 51.5 103Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3398 74.7319L64.8209 101.213C86.7531 95.3644 102.999 75.3817 102.999 51.5C102.999 51.0127 102.999 50.5253 102.999 50.0379L82.2042 30.8676L38.3398 74.7319Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8004 63.0347C55.0748 65.3091 55.0748 69.2082 52.8004 71.4826L48.089 76.194C45.8146 78.4684 41.9155 78.4684 39.6411 76.194L19.0086 55.399C16.7341 53.1246 16.7341 49.2255 19.0086 46.9511L23.7199 42.2397C25.9944 39.9653 29.8934 39.9653 32.1679 42.2397L52.8004 63.0347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8339 27.1309C73.1083 24.8564 77.0074 24.8564 79.2818 27.1309L83.9932 31.8422C86.2676 34.1167 86.2676 38.0157 83.9932 40.2902L48.2519 75.8691C45.9774 78.1435 42.0784 78.1435 39.8039 75.8691L35.0926 71.1577C32.8181 68.8832 32.8181 64.9842 35.0926 62.7097L70.8339 27.1309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_9120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.a3a0a64ff8bbe0467058a0d7e7f9d0f0.svg";
export { ForwardRef as ReactComponent };